const styles = [
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e9e9e9',
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f5f5',
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 29,
      },
      {
        weight: 0.2,
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 18,
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f5f5',
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [
      {
        color: '#dedede',
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#ffffff',
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [
      {
        saturation: 36,
      },
      {
        color: '#333333',
      },
      {
        lightness: 40,
      },
    ],
  },
  {
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f2f2f2',
      },
      {
        lightness: 19,
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#fefefe',
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#fefefe',
      },
      {
        lightness: 17,
      },
      {
        weight: 1.2,
      },
    ],
  },
];

window.initMap = function () {
  // activate main map
  if (typeof mapPosition !== 'undefined' && mapPosition) {
    const zoom = 16;

    const map = new google.maps.Map(document.getElementById('map'), {
      center: mapPosition,
      zoom,
      disableDefaultUI: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    });

    map.setOptions({ styles });

    const customMarker = new google.maps.MarkerImage(
      '/images/pin.svg',
      null /* size is determined at runtime */,
      null /* origin is 0,0 */,
      new google.maps.Point(
        30,
        60
      ) /* anchor is bottom center of the scaled image */,
      new google.maps.Size(60, 60) /* Size given in CSS Length units */
    );

    // eslint-disable-next-line no-unused-vars
    const marker = new google.maps.Marker({
      position: mapPosition,
      map,
      icon: customMarker,
    });
  }

  // activate mini maps
  const maps = document.querySelectorAll('.mini-map');
  maps.forEach((el) => {
    const lat = parseFloat(el.getAttribute('data-lat'));
    const lng = parseFloat(el.getAttribute('data-lng'));
    const mapPosition = {
      lat,
      lng,
    };

    const zoom = 14;

    const map = new google.maps.Map(el, {
      center: mapPosition,
      zoom,
      disableDefaultUI: true,
      scrollwheel: false,
      navigationControl: false,
      mapTypeControl: false,
      scaleControl: false,
      draggable: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    });

    map.setOptions({ styles });

    const customMarker = new google.maps.MarkerImage(
      '/images/pin.svg',
      null /* size is determined at runtime */,
      null /* origin is 0,0 */,
      new google.maps.Point(
        30,
        60
      ) /* anchor is bottom center of the scaled image */,
      new google.maps.Size(60, 60) /* Size given in CSS Length units */
    );

    // eslint-disable-next-line no-unused-vars
    const marker = new google.maps.Marker({
      position: mapPosition,
      map,
      icon: customMarker,
    });
  });
};
